import React, { useEffect, useState } from 'react';
import {
  Routes, Route, Navigate, useNavigate,
} from 'react-router-dom';
import { initializeAllSubscriptions } from '../channels/Global/all_subscriptions';
import Login from './Login';
import AdminDashboard from './Dashboards/AdminDashboard';
import DoctorDashboard from './Dashboards/DoctorDashboard';
import ReceptionistDashboard from './Dashboards/ReceptionistDashboard';
import LabDashboard from './Dashboards/LabDashboard';
import PharmDashboard from './Dashboards/PharmDashboard';

function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  const navigate = useNavigate();

useEffect(() => {
  const checkLogin = async () => {
    try {
      const res = await fetch('/me', { credentials: 'include' });
      const data = await res.json();

      if (res.ok) setUser(data);
      else setUser(null);
    } finally {
      setAuthChecked(true);
    }
  };

  checkLogin();
}, []);


useEffect(() => {
  if (authChecked && user) {
    initializeAllSubscriptions();
  }
}, [authChecked, user]);

  // Navigate to the correct dashboard based on role
  const roleRoutes = {
    admin: '/admin',
    doctor: '/doctor',
    receptionist: '/receptionist',
    lab_technician: '/lab',
    pharmacist: '/pharmacy',
  };

  const ProtectedRoute = ({ user, allowedRoles, children }) => {
  if (!user) return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};


 const handleLogout = async () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  try {
    const response = await fetch('/logout', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      credentials: 'include',
    });

    if (response.ok) {
      setUser(null);
      navigate('/');
    } else {
      console.error('Logout failed');
      alert('Logout failed. Please try again.');
    }
  } catch (error) {
    console.error('Error during logout:', error);
    alert('An error occurred during logout.');
  }
};

  return (
    <Routes>
      <Route
        path="/"
        element={
         user ? (
           <Navigate to={roleRoutes[user.role] || '/'} replace />

         ) : (
           <Login setUser={setUser} />
         )
        }
      />
       <Route
        path="/admin"
        element={
          <ProtectedRoute user={user} allowedRoles={['admin']}>
            <AdminDashboard user={user} handleLogout={handleLogout} />
          </ProtectedRoute>
        } />

         <Route
          path="/doctor"
          element={
            <ProtectedRoute user={user} allowedRoles={['doctor']}>
              <DoctorDashboard user={user} handleLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

         <Route
          path="/receptionist"
          element={
            <ProtectedRoute user={user} allowedRoles={['receptionist']}>
              <ReceptionistDashboard user={user} handleLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

         <Route
            path="/lab"
            element={
              <ProtectedRoute user={user} allowedRoles={['lab_technician']}>
                <LabDashboard user={user} handleLogout={handleLogout} />
              </ProtectedRoute>
            }
          />

           <Route
              path="/pharmacy"
              element={
                <ProtectedRoute user={user} allowedRoles={['pharmacist']}>
                  <PharmDashboard user={user} handleLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
     
    </Routes>

   

  );
}

export default App;
